const quickViewWarpper = document.getElementById("quickViewWrapper");

class quickViewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClickQuickViewModal);

    quickViewWarpper.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") {
        document.body.classList.remove("overflow-hidden");
        quickViewWarpper.classList.remove("show__modal");
        removeTrapFocus(this.querySelector("button.active"));
        this.querySelector("button").classList.remove("active");
      }
    });

    document.addEventListener("click", function (event) {
      let eventTarget = event.target;
      if (!eventTarget.closest(".quick_view__body")) {
        document.body.classList.remove("overflow-hidden");
        quickViewWarpper.classList.remove("show__modal");
        this.querySelector("button").classList.remove("active");
      }
    });
  }
  onClickQuickViewModal = async () => {
    let quickViewModal = this.querySelector("button");
    let productHandle = quickViewModal.dataset.productHandle;
    quickViewModal.classList.add("loading");
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${productHandle}?view=quickview`);
      const resText = await response.text();
      quickViewWarpper.innerHTML = resText;
      
      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      document.body.classList.add("overflow-hidden");
      quickViewWarpper.classList.add("show__modal");
      quickViewModal.classList.add("active");
    } catch (error) {
      console.log("error", error);
    } finally {
      quickViewModal.classList.remove("loading");
      trapFocus(quickViewWarpper);
    }
  };

}
customElements.define("quick-view-modal", quickViewModal);

class quickViewCloseTag extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.quickViewClose);
    this.currentVariant = {};
  }

  quickViewClose() {
    document.body.classList.remove("overflow-hidden");
    quickViewWarpper.classList.remove("show__modal");
    //trapFocus(document.querySelector("button.product__quick_view.active"));
    
    document
      .querySelector(".product__quick_view.active")
      .classList.remove("active");
  }
}
customElements.define("quick-view-close", quickViewCloseTag);

class QuickVariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.productInfoRequest = (this.productInfoRequest || 0) + 1;
    this.updateOptions();
    this.updateOptionsParent();
    this.updateMasterId();
    this.getPreOrderVariantData();
    this.showProductInfoError(false);

    if (!this.currentVariant) {
      this.disablePurchaseUntilUpdated();
      window.hederaVariantState.end(this.getProductForm(), true);
      this.hideProductInfo();
      const input = this.closest(".quick_view__body")
        ?.querySelector(`#product-form-${this.dataset.section} input[name="id"]`);
      if (input) {
        input.value = "";
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.disablePurchaseUntilUpdated();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateOptionsParent() {
    Array.from(this.querySelectorAll(".product-form__input--dropdown")).map(
      (select, index) => {
        select.children[0].children[1].innerHTML = this.options[index];
      }
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateVariantInput() {
    const productForms = this.closest(".quick_view__body")?.querySelectorAll(
      `#product-form-${this.dataset.section}`
    );
    productForms?.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    const variant = this.currentVariant;
    const request = this.productInfoRequest;
    fetch(
      `${this.dataset.url}?variant=${variant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => {
        if (!response.ok) throw new Error(`Product information: ${response.status}`);
        return response.text();
      })
      .then((responseText) => {
        if (!this.isConnected || request !== this.productInfoRequest ||
            this.currentVariant?.id !== variant.id) return;
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const quickView = this.closest(".quick_view__body");
        const destination = quickView?.querySelector(`#${id}`);
        //console.log(destination);
        const source = html.getElementById(id);
        if (!source) throw new Error("Product information is missing a price");
        if (destination) {
          destination.innerHTML = source.innerHTML;
          destination.style.visibility = "";
          destination.removeAttribute("aria-busy");
        }

        // HEDERA — مزامنة شارة حالة المخزون مع الـVariant المحدد (نفس آلية product-variant.js)
        const stockId = `inventory__stock--${this.dataset.section}`;
        const stockDestination = quickView?.querySelector(`#${stockId}`);
        const stockSource = html.getElementById(stockId);
        if (stockSource && stockDestination) {
          stockDestination.innerHTML = stockSource.innerHTML;
          stockDestination.className = stockSource.className;
          stockDestination.hidden = stockSource.hidden;
          stockDestination.style.visibility = "";
          stockDestination.removeAttribute("aria-busy");
        }

        const price = destination;

        if (price) price.classList.remove("no-js-inline");
        this.toggleAddButton(
          !variant.available,
          window.variantStrings.soldOut
        );
        const form = this.getProductForm();
        if (form) delete form.dataset.hdProductInfoPending;
        window.hederaVariantState.end(form);
        this.showProductInfoError(false);
        this.restorePaymentButton();
      })
      .catch((error) => {
        if (!this.isConnected || request !== this.productInfoRequest ||
            this.currentVariant?.id !== variant.id) return;
        console.error(error);
        window.hederaVariantState.end(this.getProductForm(), true);
        this.showProductInfoError(window.variantStrings.updateError || window.cartStrings.error);
      });
  }

  getProductForm() {
    return this.closest(".quick_view__body")
      ?.querySelector(`#product-form-${this.dataset.section}`);
  }

  showProductInfoError(message) {
    const formElement = this.getProductForm()?.closest("product-form");
    if (typeof formElement?.handleErrorMessage === "function")
      formElement.handleErrorMessage(message);
  }

  disablePurchaseUntilUpdated() {
    const form = this.getProductForm();
    const quickView = this.closest(".quick_view__body");
    window.hederaVariantState.begin(form, ["price-", "inventory__stock--"]
      .map(prefix => quickView?.querySelector(`#${prefix}${this.dataset.section}`)));
  }

  restorePaymentButton() {
    window.hederaVariantState.end(this.getProductForm());
  }

  hideProductInfo() {
    const quickView = this.closest(".quick_view__body");
    ["price-", "inventory__stock--"].forEach((prefix) => {
      const element = quickView?.querySelector(`#${prefix}${this.dataset.section}`);
      if (!element) return;
      element.style.visibility = "hidden";
      element.setAttribute("aria-busy", "true");
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    //console.log(this.PreorderVariantData);

    const productForm = this.closest(".quick_view__body")?.querySelector(
      `#product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;
    let state = disable ? "unavailable" : "available";
    if (disable) {
      addButton.setAttribute("disabled", true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButton.textContent = window.variantStrings.addToCart;
    }

    // HEDERA — data-preorder يحمل حالة التتبع الصريحة من Liquid. لا نعتمد
    // على رقم الكمية وحده، لأن المنتج غير المتتبَّع قد يحمل رقماً سالباً.
    const productVarArray = this.PreorderVariantData;
    const variant = this.currentVariant;
    const variantData =
      productVarArray && variant ? productVarArray[variant.id] : null;

    if (variantData && variantData.tracked === true) {
      const inventoryQuantity = Number(variantData.qty);
      const inventoryPolicy = variantData.inventory_policy;

      if (inventoryQuantity <= 0 && inventoryPolicy === "continue") {
        addButton.removeAttribute("disabled");
        addButton.textContent = window.variantStrings.preorder;
        state = "preorder";
      } else if (inventoryQuantity <= 0) {
        addButton.setAttribute("disabled", true);
        addButton.textContent = window.variantStrings.soldOut;
        state = "unavailable";
      }
    }
    this.syncPreorderProperty(productForm, state);
    if (!modifyClass) return;
  }

  syncPreorderProperty(productForm, state) {
    if (typeof window.hederaSyncPreorderProperty !== "function") return;
    window.hederaSyncPreorderProperty(productForm, state);
  }

  setUnavailable() {
    const quickView = this.closest(".quick_view__body");
    const button = quickView?.querySelector(`#product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const price = quickView.querySelector(`#price-${this.dataset.section}`);
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    this.syncPreorderProperty(button, "unavailable");
    if (price) price.classList.add("no-js-inline");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-variant]").textContent);
    return this.variantData;
  }
  getPreOrderVariantData() {
    this.PreorderVariantData =
      this.PreorderVariantData ||
      JSON.parse(this.querySelector("[data-preorder]").textContent);
  }
}

customElements.define("quick-variant-selects", QuickVariantSelects);

class QuickVariantRadios extends QuickVariantSelects {
  constructor() {
    super();
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateOptionsParent() {
    this.fieldsets.map((fieldset, index) => {
      fieldset.children[0].children[1].innerHTML = this.options[index];
    });
  }
}
customElements.define("quick-variant-radios", QuickVariantRadios);
